import { MENUICON, USERICON } from "../Utils/icons";
import MobileNav from "./MobileNav";
import AppContext from "./../Context/AppContext";
import { useContext, useEffect, useRef, useState } from "react";

export default function Header({ logoutHandler }) {
    const { token, setisSessionExpeired, session } = useContext(AppContext);

    
    
  const menuHandler = (e) => {
    const flag = document.querySelector("#hamBurger").checked;
    if (!flag) {
      if (typeof window != "undefined" && window.document) {
        document.body.style.overflow = "hidden";
      }
    } else {
      document.body.style.overflow = "unset";
    }
  };
  return (
    <div className="header-wrp">
      <div className="logo-wrp">
        <div className="logo"> {session?.entityCode ? session.entityCode : process.env.REACT_APP_APP_NAME}</div>
      </div>
      <div className="context-wrp">
        <div className="ham-icon">
          <input type="checkbox" id="hamBurger" />
          <label htmlFor="hamBurger" onClick={(e) => menuHandler(e)}>
            <MENUICON />
          </label>
          <MobileNav logoutHandler={logoutHandler} />
        </div>
        <div className="user-icon">
          <USERICON />
        </div>
      </div>
    </div>
  );
}
